/** Espera, em ms, antes de buscar depois que o usuário muda o termo de busca. */
export const SEARCH_DEBOUNCE_MS = 300;
